/**
 * On insurance packages a "doctor" is often a way of getting the service done - a home visit in a
 * province, or a partner's clinic network - described in `doctor.extra_info`. The package rules that
 * read it live in `packageBookingRules`.
 */
export interface IPackageFacility {
  state?: string;
  name?: string;
  address?: string;
}

/** The "any other province" bucket a home-care booking falls back to when nothing matches. */
export const OTHER_PROVINCE_CODE = "0";

/**
 * Province codes reach us in two spellings: the address book says `"01"`, while a doctor's config
 * may say `1` or `"1"`. Comparing them as written would never match, so both sides go through this.
 */
export const normalizeProvinceCode = (value: unknown) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return String(value);
  }

  if (typeof value !== "string" || !value.trim()) {
    return undefined;
  }

  const trimmed = value.trim();

  return /^\d+$/.test(trimmed) ? String(Number(trimmed)) : trimmed;
};
